module.exports = __webpack_public_path__ + "img/contents_catalog_no_image.3dc1ffa.png";